window.SiteReady(($) => {

  console.log('Init Block: Community Spotlight');

  if (!navigator.geolocation) {
    return;
  }

  let location = null;
  let cached = window.sessionStorage.getItem('user-community-spotlight');
  let geo = $.cookie('get', 'user-geo');

  try {
    cached = JSON.parse(window.atob(cached));
  } catch(e) {}

  try {
    location = JSON.parse(geo);
  } catch(e) {}

  if (cached && location && cached.location.lat == location.lat && cached.location.lng == location.lng) {
    renderCommunities(cached);
  } else if (location) {
    loadCommunities(location);
  } else {
    console.log('Community Spotlight: Get Geo');

    navigator.geolocation.getCurrentPosition(onGetPosition);
  }

  function onGetPosition(pos) {
    let location = {
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
    };

    $.cookie('set', 'user-geo', JSON.stringify(location), {
      path: '/',
      expires: (1000 * 60 * 60 * 24), // 24 hours
    });

    loadCommunities(location);
  }

  function loadCommunities(location) {
    console.log('Community Spotlight: Load Communities');

    $.ajax({
      url: window.THEME_OPTIONS.ajax_url,
      type: 'get',
      data: {
        action: 'load_community_spotlight',
        location: location,
        cache: true,
      },
      success: (response, status, jqXHR) => {
        if (response.indexOf('community_spotlight_ajax') !== false) {
          let data = {
            location: location,
            html: response
          };
          let cache = window.btoa(JSON.stringify(data));

          if (cache) {
            window.sessionStorage.setItem('user-community-spotlight', cache);
          }

          renderCommunities(data);
        }
      },
      error: () => {
        // console.log(arguments);
      }
    });
  }

  function renderCommunities(data) {
    console.log('Community Spotlight: Render Communities');

    if (data.html.indexOf('community_spotlight_ajax') !== false) {
      let $spotlights = $('.js-community_spotlight').not('.js-geo_loaded');

      $spotlights.each((index, el) => {
        let $el = $(el);
        let id = $el.attr('id');

        $el.replaceWith(data.html.replaceAll('community_spotlight_ajax', id));
      });
    }
  }

  //

  window.resetCommunitySpotlight = function() {
    $.cookie('delete', 'user-geo');
    window.sessionStorage.setItem('user-community-spotlight', null);
    window.location.reload();
  };

});